export function escapeHtml(s: string): string {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function escapeRegExp(str: string): string {
  return String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function cssEscape(s: string): string {
  return String(s).replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
}

export function cssEscapeAttr(s: string): string {
  return String(s).replace(/"/g, '\\"');
}

export function normalizePath(path: string): string {
  if (!path) return '/';
  return path.length > 1 ? path.replace(/\/+$/, '') : path;
}

export function getUrlParams(): Record<string, string> {
  const params: Record<string, string> = {};
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.forEach((value, key) => {
    params[key] = value;
  });
  return params;
}

export function matchesQueryParameters(
  campaignParams: Record<string, string | null>,
  urlParams: Record<string, string>,
): boolean {
  if (!campaignParams || typeof campaignParams !== 'object') return false;
  const keys = Object.keys(campaignParams);
  if (keys.length === 0) return false;

  for (const key of keys) {
    const expectedValue = campaignParams[key];
    const hasActual = Object.prototype.hasOwnProperty.call(urlParams, key);
    const actualValue = urlParams[key];

    if (expectedValue === null || expectedValue === '') {
      if (!hasActual) return false;
      continue;
    }

    if (!hasActual) return false;
    if (String(actualValue) !== String(expectedValue)) return false;
  }

  return true;
}

export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number,
): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(null, args), wait);
  };
}

export function throttle<T extends (...args: any[]) => any>(
  func: T,
  limit: number,
): (...args: Parameters<T>) => void {
  let inThrottle: boolean;
  return (...args: Parameters<T>) => {
    if (!inThrottle) {
      func.apply(null, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
}
